import { FC } from 'react';

interface OverviewHeadlineProps {
  headline: string;
}

export const OverviewHeadline: FC<OverviewHeadlineProps> = ({ headline }) => (
  <h2 className="stihl-text-h2-mobile desktop:stihl-text-h2-desktop">{headline}</h2>
);
